export class ToolUpdate {
  calibrationNext: Date;
  calibrationFrequency: number;
  calibrationInterval: string;
  serviceNext: Date;
  serviceFrequency: number;
  serviceInterval: string;
  department: string;
  calibrationStatus: string;
  locationName: string;
  locationDescription: string;
  isActive: boolean;
  notes: string;

  public constructor(init?: Partial<ToolUpdate>) {
    Object.assign(this, init);
  }
}
